export const css = {
	root: '_1sG4AWV5',
	input: '_2jXv49RZ',
	disabled: '_3FFoiNag',
	readonly: '_2k5QtWxb',
	invalid: '_3skJEqey',
	valid: 'pXrLF4n2',
	' _key': 'afcpe-theme/dojo/text-area'
};

export default css;
